import PlatformActions from './PlatformActions'

export default class PENGUINKINGActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'PENGUINKING',
      gameType: 'SLOT',
      gameCode: 'PENGUINKING-SLOT-025',
    }

    this.gameName = 'Boom the Buffoon'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`, // OP051-oct-992febe0-d5fa-446b-a1cc-000000000870_OP051-oct-992febe0-d5fa-446b-a1cc-0000000010cd
      roundId: `OP051-oct-${roundId}`, // OP051-oct-992febe0-d5fa-446b-a1cc-000000000870
      betType: null,
      currency,
      betTime, // 2026-09-08T12:01:32.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`, // OP051-oct-992febe0-d5fa-446b-a1cc-000000000870_OP051-oct-992febe0-d5fa-446b-a1cc-0000000010ce
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2026-09-08T12:01:33.759+08:00
      roundId: `OP051-oct-${roundId}`, // OP051-oct-992febe0-d5fa-446b-a1cc-000000000870
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`,
      roundId: `OP051-oct-${roundId}`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
